import { useSelector } from 'src/store/react';
import { selectKeywordField, selectWhereField } from 'src/store/selectors';

export const useMinSearchBarText = () => {
  const keywordsField = useSelector(selectKeywordField);
  const whereField = useSelector(selectWhereField);
  const separator = ' • ';

  if (keywordsField && whereField) {
    return `${keywordsField}${separator}${whereField}`;
  }

  if (keywordsField) {
    return keywordsField;
  }

  if (whereField) {
    return whereField;
  }

  return '';
};
